import axios from "axios";
import {
  INDICATOR_LOAD_ATTEMPT,
  INDICATOR_LOAD_SUCCESS,
  INDICATOR_LOAD_FAILED,
} from "../types/indicatorTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: INDICATOR_LOAD_ATTEMPT };
}

export function success(data) {
  return { type: INDICATOR_LOAD_SUCCESS, data };
}

export function failed(error) {
  return { type: INDICATOR_LOAD_FAILED, error };
}

export const loadList = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "summary/indicators", {
      params: { id: data.user_id, period: data.period || "month" },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(failed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
